<template>
  <div class="text-center">
    <v-overlay z-index="9999" >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
export default {
  name: 'progressSpinner'
}
</script>